/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "configure",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fillRule": "evenodd",
                "clipRule": "evenodd",
                "fill": "#666666"
            },
            "configure": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "87",
            "height": "87"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 87 87", className: "configure", width: this.props.width, height: this.props.height, style: this.props.configure },
            _react2["default"].createElement("path", { className: "st0", d: "M3.6 83c-5.2-5.8-3.2-9-3.2-9l44.7-44.2c-.8-2-1.3-4-1.5-6.1-.2-2.1-.1-4.1.3-6.2.4-2 1.1-4 2.1-5.9 1-1.9 2.3-3.6 3.9-5.2 1.4-1.5 3-2.7 4.8-3.6 1.7-1 3.5-1.7 5.4-2.1 1.8-.5 3.7-.7 5.6-.7 1.9 0 3.8.3 5.6.8L54.5 17.6l14.8 14.7 16.8-16.8c.5 1.8.8 3.7.9 5.6.1 1.9-.1 3.8-.6 5.6-.5 1.9-1.2 3.6-2.2 5.4-1 1.7-2.2 3.3-3.7 4.8-1.6 1.6-3.3 2.9-5.2 3.9-1.9 1-3.9 1.7-5.9 2.1-2 .4-4.1.5-6.2.3-2.1-.2-4.1-.7-6.1-1.5l-45.2 45c0 .1-3.5 1.7-8.3-3.7z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/configure.js